import { render, staticRenderFns } from "./addOrgaBuild.vue?vue&type=template&id=1a6e0cd5&scoped=true"
import script from "./addOrgaBuild.vue?vue&type=script&lang=js"
export * from "./addOrgaBuild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6e0cd5",
  null
  
)

export default component.exports